import { Component, OnInit, Injector } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import _moment from 'proxies/dayjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareMultiDropDownData } from 'src/modules/base/components/search-select/multi-select.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { OtSlots, PatientDetails } from './common/ot-slot-model';
import { OtService } from './common/ot.service'
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { OtSlotsViewComponent } from './ot-slots-view/ot-slots-view.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { Location } from '@angular/common'
import BaseDecorator from 'src/modules/base/base-decorator';
import { TemplateInterceptorComponent } from 'src/modules/base/components/template-interceptor/template-interceptor.component';

@Component({
  selector: 'kx-ot-slots',
  templateUrl: './ot-slots.component.html',
  styleUrls: ['./ot-slots.component.scss'],
  standalone: false
})
export class OtSlotsComponent extends BaseDecorator implements OnInit {
  OTName: any;
  showButton: boolean = false;
  disabledButton: boolean = false;
  surgeryNotesAsPerMaster: boolean = false;
  parentId: any = JSON.parse(sessionStorage.currentData)['parent_id'];

  otSlots: OtSlots
  patientDetails: PatientDetails
  doctorSlots: any;
  doctor_id: any;
  showSlots: boolean = true;
  showTmeSlots: boolean = true;
  self: this;
  autoSelectedSlots: any = {
    service_start_time: "",
    service_end_time: ""
  };
  config = {
    "add_required": true,
    "table": true,
    "tile": false,
    "decorator": "SurgeryDecorator"
  }
  careType: any;
  careTypeName: any;
  cArmArray: any = [];
  otNameQuestion: SearchAndSelect;
  decorator: any;
  resourceDef: any;
  formConfig = {
    "submitButton": false,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": ''
  }
  formData: any = {};
  opAmount: any = {};
  question = {
    'expression': "!items.find(key=>key.service_id==item.service_id && key.machine_id==item.machine_id)",
    'hideEdit': true
  }
  numKey: any;
  rescheduleReasonRemarkMandate: boolean = false;
  opPackageValidationFailed: boolean = false;

  constructor(
    private baseService: BaseService,
    public router: ActivatedRoute,
    private alertService: AlertsService,
    public location: Location,
    public appService: AppService,
    public injector: Injector,
    public MultiDropDownService: ShareMultiDropDownData,
    private otService: OtService,
    private storageService: StorageService,
    private loader: LoaderService
  ) {
    super(router, 'OtSlotsComponent', injector)
    this.otSlots = new OtSlots()
    this.patientDetails = new PatientDetails();
    this.self = this;
  }

  locale = {
    "format": "DD/MM/YYYY HH:mm"
  }

  ngOnInit() {
    if (this.config != undefined && this.config.decorator != undefined) {
      this.decorator = this.baseService.initDecorator(this.config.decorator, this.route, this.injector);
    }
    this.otSlots.currentDate = _moment().valueOf();
    this.otSlots.serviceDate = _moment().subtract(0, 'days').startOf('day').valueOf();
    this.baseService.get('GET_CONFIG', 'module_code:ot,config_code:surgery_notes_mandatory_as_per_surgery_master', 'facility_config_mapping', 'facility-management').subscribe(res => {
      if (res.errCode == 0 && res.resource.length > 0) {
        this.surgeryNotesAsPerMaster = res.resource[0].config_value == 'yes' ? true : false;
      }
    })
    if (this.router.snapshot.queryParams.banner == '"Rescheduling"') {
      // this.otSlots.btnDisabled = true;
      this.baseService.setTitle("Reschedule Surgery/Package");
      this.otSlots.rescheduling = "Reschedule Surgery/Package";
      this.otSlots.deptbtnDisabled = true;
      this.otSlots.surgerybtnDisabled = true;
      this.otSlots.packagebtnDisabled = true;
      this.otSlots.specialitybtnDisabled = true;
      this.recheduleReason();
    }
    else {
      this.baseService.setTitle("Schedule Surgery/Package");
      this.otSlots.deptbtnDisabled = true;
      this.otSlots.surgerybtnDisabled = true;
      this.otSlots.packagebtnDisabled = false;
      this.otSlots.specialitybtnDisabled = false;
      this.otSlots.scheduling = "Schedule Surgery/Package";
      this.storageService.getSessionStorageData("currentData", (res: any) => {
        if (res.request_type.toLowerCase() == "package") {
          this.otSlots.deptbtnDisabled = true;
          this.otSlots.packagebtnDisabled = true
        }
      })
    }

    var field = {};
    this.otSlots.question = new SearchAndSelect({
      label: field['label'],
      datasource: this.otSlots.datasource,
      defaultsetting: this.otSlots.defaultsetting,
      order: field['order'],
      visible: field['visible'],
      key: field['name'],
      value: field['Value'],
      required: field['required'],
      conditions: field['conditions'],
      id: field['id'],
      getterKey: 'id',
      getterValue: 'serviceItemName',
      format: field['format'],
      options: false,
      set_object: field['set_object']
    });
    this.getDepartment();
  }

  getPatientData(patientData) {
    this.otSlots.patientData = patientData;
    this.otSlots.id = patientData.id;
    this.otSlots.expected_surgery_date_time = patientData.expected_surgery_date_time;
    this.otSlots.department_id = patientData.department_id;
    this.otSlots.serviceItemId = patientData.serviceItemId;
    this.otSlots.serviceItemName = patientData.serviceItemName;
    this.otSlots.surgeon_speciality_id = patientData.surgeon_speciality_id;
    this.otSlots.surgeon_id = patientData.surgeon_id;
    this.otSlots.doctor_id = patientData.doctor_id;
    this.otSlots.surgery_type = patientData.surgery_type;
    this.patientDetails.patient_id = patientData.patient_id;
    this.patientDetails.patientType = patientData.patientType;
    this.patientDetails.encounter_id = patientData.encounter_id;
    this.patientDetails.payer_id = patientData.payer_id;
    this.patientDetails.finance_clearance = patientData.finance_clearance;
    this.patientDetails.admissionId = patientData.encounter_id;
    this.patientDetails.uhId = patientData.uhId;
    this.otSlots.surgery_grade_id = patientData.surgery_grade_id;
    this.otSlots.request_type = patientData.request_type;
    this.otSlots.serviceType = patientData.serviceType;
    this.otSlots.serviceType_code = patientData.serviceType_code;
    this.otSlots.kinContact = patientData.kinContact;
    this.otSlots.kinRelationship = patientData.kinRelationship;
    this.otSlots.kinGender = patientData.kinGender;
    this.otSlots.kinName = patientData.kinName;
    this.getSurgeryName(patientData.department_id);
    this.getSurgeonSpeciality();
    this.otSlots.OTId = patientData.ot_id == undefined ? "" : patientData.ot_id;
    this.autoSelectedSlots.service_start_time = patientData.service_start_time
    this.autoSelectedSlots.service_end_time = patientData.service_end_time
    this.careType = patientData.care_type == undefined ? "" : patientData.care_type;
    this.careTypeName = patientData.care_type_name == undefined ? "" : patientData.care_type_name;
    if (this.patientDetails.patientType == 'OP' && this.otSlots.request_type == 'Package') {
      this.opPackageValidation();
    }
    this.cArmArray = patientData['equipment_details'] ? patientData['equipment_details'] : [];
    this.getSurgeonName(patientData.surgeon_speciality_id);
    this.getMultiSurgeryName(patientData.serviceItemId);
    this.getOTList(patientData.surgery_type);
    this.getSurgeryGradeData();
    this.getMainSurgeon(this.otSlots.doctor_id);
    // this.getOtFinanceClearance();
    this.getOpAmount(this.otSlots.serviceItemId);
    if (this.otSlots.OTId) {
      this.getAppointsSlots(this.otSlots.currentDate, this.otSlots.OTId);
    }
    if (this.otSlots.surgery_type == "CathLab") {
      this.otSlots.datasource = {
        "query_id": "GET_SURGERY_REQUESTS_BY_PARENTID",
        "args": "surgery_type:CathLab,parent_id:" + this.parentId + ",id:" + this.router.queryParams['value']['key'],
        "application": "ot",
        "filter": "request_type:" + this.otSlots.request_type,
        "default_args": "surgery_type:CathLab",
        "resource": "cathlab_surgery_request"
      }
    }
    else if (this.otSlots.surgery_type == "OT") {
      this.otSlots.datasource = {
        "query_id": "GET_SURGERY_REQUESTS_BY_PARENTID",
        "args": "surgery_type:OT,parent_id:" + this.parentId + ",id:" + this.router.queryParams['value']['key'],
        "application": "ot",
        "filter": "request_type:" + this.otSlots.request_type,
        "default_args": "surgery_type:OT",
        "resource": "surgery_request"
      }
    }
    if (this.otSlots.request_type == 'Surgery') {
      this.baseService.getResourceDef('surgery_request_checkbox', (data) => {
        this.resourceDef = data;
      })
    }
    if (this.otSlots.request_type == 'Package') {
      this.baseService.getResourceDef('package_request_checkbox', (data) => {
        this.resourceDef = data;
      })
    }
  }

  recheduleReason() {
    this.baseService.get('GET_CONFIG', 'module_code:facility-management,config_code:facility_mgnt_0011', 'facility_config_mapping', 'facility-management').subscribe(result => {
      if (result.errCode == 0) {
        result = result.resource[0];
        if (result && result.multivalue && result.multivalue.filter(x => x.id == "reschedule_surgery").length != 0) {
          this.rescheduleReasonRemarkMandate = true
        }
      }
    })
    this.baseService.get('getReasonNameBasedOnReasonType', "facility_master_type:REASON,reasontype_id:reschedule_surgery", "facility_master", "facility-management").subscribe((res) => {
      if (res.errCode == 0 && res.resource) {
        this.otSlots.rescheduleReasons = res.resource;
      }
    })
  }

  public getSurgeryGradeData() {
    var hasArgs = {
      args: "id:" + this.otSlots.surgery_grade_id
    }
    this.baseService.getData(hasArgs, "", "surgery_grade_master", "facility-management", "GET_BY_ID").subscribe((res) => {
      if (res.errCode == 0 && res.resource) {
        this.otSlots.surgeryGradeList = res.resource;
        if (res.resource[0] != undefined && res.resource[0].duration_min != undefined) {
          this.otSlots.DurationMin = res.resource[0].duration_min;
          this.otSlots.surgeryGradeDurationMin = this.otSlots.DurationMin * 60 * 1000;
        }
      }
    })
  }

  public getAppointsSlots(date: any, event: any) {
    this.showButton = false;
    if (this.otSlots.checkboxvalue == 'acknowledged') {
      this.showButton = true;
    }
    var slotDate = _moment(date).subtract(0, 'days').startOf('day').valueOf();
    var slotDay = _moment(date).format('dd').toUpperCase();
    if (this.otSlots.general_slots || this.otSlots.prime_slots) {
      if (this.otSlots.surgery_type == 'OT') {
        var hasArgs = {
          args: "roomtype_id:ot,ot_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay + ",care_type:" + (this.careType == 'prime' ? 'general' : 'prime')
        }
      }
      else if (this.otSlots.surgery_type == 'CathLab') {
        var hasArgs = {
          args: "roomtype_id:cathlab,ot_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay + ",care_type:" + (this.careType == 'prime' ? 'general' : 'prime')
        }
      }
    }
    else {
      if (this.otSlots.surgery_type == 'OT') {
        var hasArgs = {
          args: "roomtype_id:ot,ot_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay + ",care_type:" + this.careType,
        }
      }
      else if (this.otSlots.surgery_type == 'CathLab') {
        var hasArgs = {
          args: "roomtype_id:cathlab,ot_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay + ",care_type:" + this.careType,
        }
      }
    }
    // surgeon-wise OT/Cathlab scheduling: backend returns only slots open to this surgeon
    if (hasArgs && this.otSlots.surgeon_id) {
      hasArgs.args += ",surgeon_id:" + this.otSlots.surgeon_id;
    }
    this.baseService.getData(hasArgs, "", "ot_slot", "ot", "OT_SLOT_LIST").subscribe((slots) => {
      // if (this.otSlots.exist = this.patientDetails.finance_clearance) {
      if (slots.errCode == 0 && slots.resource) {
        this.otSlots.slots = slots.resource;
      }
      else {
        this.otSlots.slots = []
      }
      this.otSlots.showAcknowledge = true;
      this.otSlots.multipleSlots = true;
      // if (this.otSlots.exist == true) {
      //   if (this.patientDetails.finance_clearance == true) {
      //     if (slots.errCode == 0 && slots.resource) {
      //       this.otSlots.slots = slots.resource;
      //     }
      //     else {
      //       this.otSlots.slots = []
      //     }
      //     this.otSlots.showAcknowledge = true;
      //     this.otSlots.multipleSlots = true;
      //   }
      //   else if (this.patientDetails.finance_clearance == false) {
      //     this.alertService.error("Please Finance Clearance!!!")
      //   }
      // }
      // else {
      //   if (slots.errCode == 0 && slots.resource) {
      //     this.otSlots.slots = slots.resource;
      //   }
      //   else {
      //     this.otSlots.slots = []
      //   }
      //   this.otSlots.showAcknowledge = true;
      //   this.otSlots.multipleSlots = true;
      // }
    })
  }

  getMainSurgeon(id: any) {
    if (this.otSlots.patientData.surgeon_details == undefined) {
      this.otSlots.patientData.surgeon_details = []
    }
    this.baseService.get("GET_PAGE", "", "facility_master_surgery_billing_component", "facility-management", "is_surgeon:true").subscribe((result) => {
      if (result.errCode == 0 && result.resource.length != 0) {
        this.baseService.get("GET_BY_ID", "id:" + id, "practitioner_facility_details_doctor", "facility-management").subscribe((res) => {
          if (res.errCode == 0 && res.resource.length != 0) {
            if (res.resource[0].isSurgeon && res.resource[0].surgery_billing_component_id.find(val => val.text == result.resource[0].display)) {
              let obj = {
                care_professional_surgeon_id: "",
                context_menu: true,
                doctor_id: id,
                is_surgeon: true,
                surgeon: this.otSlots.patientData.surgeon,
                surgeon_id: this.otSlots.patientData.surgeon_id,
                surgeon_speciality: this.otSlots.patientData.surgeon_speciality,
                surgeon_speciality_code: this.otSlots.patientData.surgeon_speciality_code,
                surgeon_speciality_id: this.otSlots.surgeon_speciality_id,
                surgery_billing_component: result.resource[0].display,
                surgery_billing_component_Id: result.resource[0].id,
                surgery_component_type: 'doctor',
                surgery_type: "",
              }
              this.otSlots.patientData.surgeon_details.push(obj);
            }
          }
        })
      }
    })
  }

  getOpAmount(data) {
    if (this.patientDetails.patientType == 'OP') {
      let obj = {
        "payer_details": {
          "payer_id": this.patientDetails.payer_id
        },
        "facility_id": this.appService.getOrganization().org_id,
        "patient_id": this.patientDetails.patient_id,
        "uhId": this.patientDetails.uhId,
        'billing_category_id': this.otSlots.patientData.billing_category_id,
        'billing_category_name': this.otSlots.patientData.billing_category,
        "orderedFrom": "OT Order",
        "services": [
          {
            "serviceItemId": data,
            "serviceItemCode": "surgery",
            "serviceItemName": this.otSlots.serviceItemName,
            "order_date_time": new Date().getTime(),
            "serviceId": data,
            "qty": 1,
            "priorityCode": null,
            "order_frequency": "",
            "serviceType_code": "surgery",
            "patient_instructions": ""
          }
        ],
        "care_type": this.careType,
        "tag_data": [
        ]
      }
      this.baseService.action(obj, 'GET_AMOUNT', 'facility-management', 'op_amount').subscribe(
        (res: any) => {
          if (res.errCode == 0 && res.resource.length > 0) {
            if (res.resource[0].is_failed_items) {
              this.alertService.error(res.resource[0].failed_items_message);
            }
            else {
              this.opAmount.patient_amount = res.resource[0].services[0].patient_amount,
                this.opAmount.discount = res.resource[0].services[0].discount,
                this.opAmount.price = res.resource[0].services[0].price,
                this.opAmount.total_amount = res.resource[0].services[0].total_amount,
                this.opAmount.net_amount = res.resource[0].services[0].net_amount,
                this.opAmount.service_mrp = res.resource[0].services[0].service_mrp,
                this.opAmount.service_selling_amount = res.resource[0].services[0].service_selling_amount
              this.opAmount.priorityCode = res.resource[0].services[0].priorityCode
              this.opAmount.priority = res.resource[0].services[0].priority
            }
          }
        })
    }
  }

  public getDepartment() {
    var hasArgs = {
      args: "resourceType:department,status:active"
    }
    this.baseService.getData(hasArgs, "", "organization", "facility-management", "GET_BY_RESOURCETYPESTATUS").subscribe((departmentList) => {
      this.otSlots.departmentList = departmentList.resource
    })
  }

  public getSurgeryName(event: any) {
    if (this.otSlots.surgery_type == 'CathLab' && this.otSlots.request_type == 'Surgery') {
      var hasArgs = {
        args: "serviceType_Code:surgery,surgery_type:CathLab,status:active,department_id:" + event
      }
    }
    else if (this.otSlots.surgery_type == 'CathLab' && this.otSlots.request_type == 'Package') {
      var hasArgs = {
        args: "serviceType_Code:package,status:active,department_id:" + event
      }
    }
    else if (this.otSlots.surgery_type == 'OT' && this.otSlots.request_type == 'Surgery') {
      var hasArgs = {
        args: "serviceType_Code:surgery,surgery_type:OT,status:active,department_id:" + event
      }
    }
    else if (this.otSlots.surgery_type == 'OT' && this.otSlots.request_type == 'Package') {
      var hasArgs = {
        args: "serviceType_code:package,status:active,department_id:" + event
      }
    }
    this.baseService.getData(hasArgs, "", "catalog_entry", "facility-management", "GET_SERVICEITEM").subscribe((surgeryName) => {
      this.otSlots.surgeryName = surgeryName.resource
    })
  }

  public getMultiSurgeryName(event: any) {
    if (this.otSlots.surgery_type == 'CathLab') {
      var hasArgs = {
        args: "surgery_type:CathLab,parent_id:" + this.parentId + ",id:" + this.router.queryParams['value']['key']
      }
      this.baseService.getData(hasArgs, "", "cathlab_surgery_request", "ot", "GET_SURGERY_REQUESTS_BY_PARENTID").subscribe(res => {
        if (res.errCode == 0) {
          this.otSlots.multisurgeryName = res.resource;
        }
      })
    }
    else if (this.otSlots.surgery_type == 'OT') {
      var hasArgs = {
        args: "surgery_type:OT,parent_id:" + this.parentId + ",id:" + this.router.queryParams['value']['key']
      }
      this.baseService.getData(hasArgs, "", "surgery_request", "ot", "GET_SURGERY_REQUESTS_BY_PARENTID").subscribe(res => {
        if (res.errCode == 0) {
          this.otSlots.multisurgeryName = res.resource;
          //console.log("multisurgeryName list is :: ", this.otSlots.multisurgeryName);
          // this.showMultiselectDropdown = true;
        }
      })
    }
  }

  questionValueChanged(event) {
    this.formData = event.form.value
  }

  setForm(form: any, action: any = "ADD") {
    super.setForm(form, action);
    if (this.surgeryNotesAsPerMaster && this.otSlots.request_type == 'Surgery' && this.otSlots.serviceItemId && form.controls.surgery_notes) {
      this.baseService.get('GET_PAGE', '', 'surgery_detail', 'facility-management', 'surgery_id:' + this.otSlots.serviceItemId).subscribe((res) => {
        if (res.errCode == 0 && res.resource && res.resource.length > 0) {
          this.applyMasterSurgeryNotes(form, res.resource[0]);
        }
      })
    }
  }

  // if surgery notes is mandatory at surgery master level, keep it checked and do not allow user to un-check
  applyMasterSurgeryNotes(form, surgeryDetail) {
    let control = form.controls.surgery_notes;
    let isMandatory = surgeryDetail && (surgeryDetail.surgery_notes == true || surgeryDetail.surgery_notes == 'true');
    if (!control || !isMandatory) {
      return;
    }
    control.setValue(true);
    this.formData = form.value;
    let question = control.question_component ? control.question_component.question : this.formService && this.formService.questionMapping ? this.formService.questionMapping['surgery_notes'] : undefined;
    if (question) {
      question['disabled'] = true;
    }
  }

  valueChangeStart(e: any, formObj) {
    if (e.question && e.question.key == "standard_codes" && e.val && (e.val[0] == undefined)) {
      formObj.form.controls.standard_codes.setValue([])
    }
    if (e && e.question && e.question.key == 'surgical_indicator_code' && formObj.form.controls['surgical_indicator_code'].value != '') {
      this.formService.questionMapping.re_exploration_remarks.visible = true;
      this.formService.questionMapping.re_exploration_reason.visible = true;
      this.formService.questionMapping.re_exploration_reason.required = true;
    }
    if (e && e.question && e.question.key == 'surgical_indicator_code' && formObj.form.controls['surgical_indicator_code'].value == '') {
      this.formService.questionMapping.re_exploration_remarks.visible = false;
      this.formService.questionMapping.re_exploration_reason.visible = false;
      this.formService.questionMapping.re_exploration_reason.required = false;
    }
    if (e && e.question && e.question.key == 'surgery_component_type') {
      let hasArgs = {
        "args": "surgery_id:" + this.otSlots.serviceItemId,
      }
      if (formObj.form.controls.surgeon_speciality_id) {
        this.baseService.getData(hasArgs, "", "catalog_entry", "facility-management", "GET_BY_SURGERY_ID").subscribe((res) => {
          if (res.errCode == 0 && res.resource) {
            this.formService.compositeQuestionMapping.surgeon_details.surgeon_speciality_id.options = res.resource[0].ordering_speciality
            this.formService.compositeQuestionMapping.surgeon_details.surgeon_speciality_id.getterValue = "text"
            this.formService.compositeQuestionMapping.surgeon_details.surgeon_speciality_id.dependents = [
              {
                "dependent_field": "surgeon_speciality_code",
                "value": "value",
                "action": "populate_field"
              },
              {
                "dependent_field": "surgeon_speciality",
                "value": "text",
                "action": "populate_field"
              },
              {
                "dependent_field": "doctor_id",
                "resource": "practitioner_facility_details_doctor",
                "query_id": "GET_DOCTOR_BY_SPECIALITY_CODE_BILLCOMPONENT",
                "composite_args": [
                  {
                    "type": "dynamic",
                    "key": "speciality",
                    "value": "surgeon_speciality_code"
                  },
                  {
                    "type": "dynamic",
                    "key": "surgery_billing_component",
                    "value": "surgery_billing_component"
                  }
                ],
                "application": "facility-management",
                "action": "change_value"
              }
            ]
          }
        })
      }
      if (formObj.form.value.surgery_component_type == 'doctor' || formObj.form.value.surgery_component_type == 'anaesthetist') {
        this.formService.questionMapping.surgeon_details.item_key = "doctor_id";
      }
      else if (formObj.form.value.surgery_component_type == 'care_professional') {
        this.formService.questionMapping.surgeon_details.item_key = "care_professional_doctor_id";
      }
    }
  }

  valueChangeEnd(e: any, formObj) {
    if (e && e.question && (e.question.key == "surgery_billing_component_Id" || e.question.key == "surgeon_speciality_id")) {
      if (formObj.form.controls.surgeon_speciality_code && formObj.form.controls.surgery_billing_component && formObj.form.controls.surgery_billing_component.value && formObj.form.controls.surgery_billing_component.value.includes('Assistant') && formObj.form.controls.surgeon_speciality_code.value) {
        if (formObj.form.controls.doctor_id && formObj.form.controls.doctor_id.question_component) {
          formObj.form.controls.doctor_id.question_component.question['datasource'] = {
            "application": "facility-management",
            "resource": "assistant_surgeon_mapping_master",
            "query_id": "GET_ASSISTANT_SURGEONS",
            "args": "speciality_code:" + formObj.form.controls.surgeon_speciality_code.value + ",assistantToId:" + this.otSlots.doctor_id,
          };
          this.formService.baseService.getByDataSource(formObj.form.controls.doctor_id.question_component.question['datasource']).subscribe((res) => {
            if (res.errCode == 0 && res.resource.length != undefined && res.resource.length > 0) {
              setTimeout(() => {
                formObj.form.controls.doctor_id.question_component.question['options'] = res.resource;
                formObj.form.controls.show_all.question_component.question['visible'] = true;
                formObj.form.controls.doctor_id.question_component.question['getterValue'] = 'assistant_surgeon';
                formObj.form.controls.doctor_id.question_component.question['getterKey'] = 'assistant_surgeon_id';
                formObj.form.controls.doctor_id.question_component.question['dependents'] = [
                  {
                    "dependent_field": "surgeon",
                    "value": "assistant_surgeon",
                    "action": "populate_field"
                  },
                  {
                    "dependent_field": "surgeon_id",
                    "value": "assistant_surgeon_code",
                    "action": "populate_field"
                  }
                ]
              }, 600)
            }
            else {
              formObj.form.controls.doctor_id.question_component.question['getterValue'] = 'display_name';
              formObj.form.controls.doctor_id.question_component.question['getterKey'] = 'id';
              formObj.form.controls.doctor_id.question_component.question['dependents'] = [
                {
                  "dependent_field": "surgeon",
                  "value": "display_name",
                  "action": "populate_field"
                },
                {
                  "dependent_field": "surgeon_id",
                  "value": "practitioner_id",
                  "action": "populate_field"
                }
              ]
            }
          });
        }
      }
      else if (formObj.form.controls.doctor_id && formObj.form.controls.doctor_id.question_component) {
        formObj.form.controls.doctor_id.question_component.question['getterValue'] = 'display_name';
        formObj.form.controls.doctor_id.question_component.question['getterKey'] = 'id';
        formObj.form.controls.doctor_id.question_component.question['dependents'] = [
          {
            "dependent_field": "surgeon",
            "value": "display_name",
            "action": "populate_field"
          },
          {
            "dependent_field": "surgeon_id",
            "value": "practitioner_id",
            "action": "populate_field"
          }
        ]
      }
    }
    if (e && e.question && (e.question.key == "show_all") && formObj.form.controls.show_all && formObj.form._manualChange) {
      if (formObj.form.controls.show_all.value) {
        if (formObj.form.controls.doctor_id && formObj.form.controls.doctor_id.question_component) {
          formObj.form.controls.doctor_id.question_component.question['datasource'] = {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "query_id": "GET_DOCTOR_BY_SPECIALITY_CODE_BILLCOMPONENT",
            "args": "speciality:" + formObj.form.controls.surgeon_speciality_code.value + ",surgery_billing_component:" + formObj.form.controls.surgery_billing_component.value,
          };
          this.formService.baseService.getByDataSource(formObj.form.controls.doctor_id.question_component.question['datasource']).subscribe((res) => {
            if (res.errCode == 0 && res.resource.length != undefined && res.resource.length > 0) {
              formObj.form.controls.doctor_id.question_component.question['options'] = res.resource;
              formObj.form.controls.doctor_id.question_component.question['getterValue'] = 'display_name';
              formObj.form.controls.doctor_id.question_component.question['getterKey'] = 'id';
              formObj.form.controls.doctor_id.question_component.question['dependents'] = [
                {
                  "dependent_field": "surgeon",
                  "value": "display_name",
                  "action": "populate_field"
                },
                {
                  "dependent_field": "surgeon_id",
                  "value": "practitioner_id",
                  "action": "populate_field"
                }
              ]
            }
          });
        }
      }
      else {
        if (formObj.form.controls.doctor_id && formObj.form.controls.doctor_id.question_component) {
          formObj.form.controls.doctor_id.question_component.question['datasource'] = {
            "application": "facility-management",
            "resource": "assistant_surgeon_mapping_master",
            "query_id": "GET_ASSISTANT_SURGEONS",
            "args": "speciality_code:" + formObj.form.controls.surgeon_speciality_code.value + ",assistantToId:" + this.otSlots.doctor_id,
          };
          this.formService.baseService.getByDataSource(formObj.form.controls.doctor_id.question_component.question['datasource']).subscribe((res) => {
            if (res.errCode == 0 && res.resource.length != undefined && res.resource.length > 0) {
              formObj.form.controls.doctor_id.question_component.question['options'] = res.resource;
              formObj.form.controls.show_all.question_component.question['visible'] = true;
              formObj.form.controls.doctor_id.question_component.question['getterValue'] = 'assistant_surgeon';
              formObj.form.controls.doctor_id.question_component.question['getterKey'] = 'assistant_surgeon_id';
              formObj.form.controls.doctor_id.question_component.question['dependents'] = [
                {
                  "dependent_field": "surgeon",
                  "value": "assistant_surgeon",
                  "action": "populate_field"
                },
                {
                  "dependent_field": "surgeon_id",
                  "value": "assistant_surgeon_code",
                  "action": "populate_field"
                }
              ]
            }
            else {
              formObj.form.controls.doctor_id.question_component.question['getterValue'] = 'display_name';
              formObj.form.controls.doctor_id.question_component.question['getterKey'] = 'id';
              formObj.form.controls.doctor_id.question_component.question['dependents'] = [
                {
                  "dependent_field": "surgeon",
                  "value": "display_name",
                  "action": "populate_field"
                },
                {
                  "dependent_field": "surgeon_id",
                  "value": "practitioner_id",
                  "action": "populate_field"
                }
              ]
            }
          });
        }
      }
    }
  }

  //   valueChangeEnd(e: any, formObj) {
  //     console.log(e, formObj)
  //     if (formObj.form.controls.surgeon_details != undefined && formObj.form.controls.surgeon_details.value.length != 0) {
  //         let num: any;
  //         for (let i = 0; i < formObj.form.controls.surgeon_details.value.length; i++) {
  //             if (formObj.form.controls.surgeon_details.value[i].is_surgeon == true) {
  //                 num = 1;
  //                 break;
  //             }
  //             else
  //                 num = 0;
  //         }
  //         if (num == 1 && this.formService.compositeQuestionMapping.surgeon_details != undefined) {
  //             setTimeout(() => {
  //                 this.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = false;
  //             }, 600)
  //         }
  //         else if (num == 0 && this.formService.compositeQuestionMapping.surgeon_details != undefined) {
  //             this.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = true;
  //         }
  //         this.numKey = num;
  //     }
  //     else if (formObj.form.controls.surgeon_details != undefined && formObj.form.controls.surgeon_details.value.length == 0 && this.formService.compositeQuestionMapping.surgeon_details != undefined) {
  //         this.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = true;
  //         this.numKey = 0;
  //     }
  //     if (this.numKey == 1 && e.question != undefined && e.question.key && e.question.key == 'surgery_component_type' && formObj.form._manualChange) {
  //         setTimeout(() => {
  //             this.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = false;
  //         }, 600)
  //     }
  // }

  public getSurgeonSpeciality() {
    let hasArgs = {
      "args": "surgery_id:" + this.otSlots.serviceItemId,
    }
    this.baseService.getData(hasArgs, "", "catalog_entry", "facility-management", "GET_BY_SURGERY_ID").subscribe((surgeonSpeciality) => {
      // console.log("surgeryName list is :: 1", surgeonSpeciality);
      if (surgeonSpeciality.errCode == 0 && surgeonSpeciality.resource.length > 0) {
        this.otSlots.surgeonSpeciality = surgeonSpeciality.resource[0].ordering_speciality
      }
    })
  }

  public getSurgeonName(event: any) {
    var hasArgs = {
      args: "speciality_id:" + event
    }
    this.baseService.getData(hasArgs, "", "practitioner_facility_details_doctor", "facility-management", "GET_DOCTOR_BY_SPECIALITY").subscribe((surgeonName) => {
      this.otSlots.surgeonData = surgeonName.resource
    })
  }

  onSurgeonChange(event: any) {
    this.otSlots.doctor_id = event;
    let surgeon = this.otSlots.surgeonData ? this.otSlots.surgeonData.find(val => val.id == event) : undefined;
    if (surgeon) {
      this.doctor_id = surgeon.practitioner_id;
      this.otSlots.surgeon_id = surgeon.practitioner_id;
    }
    else {
      this.doctor_id = "";
      this.otSlots.surgeon_id = "";
    }
    // surgeon changed: the old pick may now be reserved for someone else
    this.otSlots.selectedSlot = undefined;
    this.showButton = false;
    if (this.otSlots.OTId) {
      this.getAppointsSlots(this.otSlots.currentDate, this.otSlots.OTId);
    }
  }

  public getOTList(event: any) {
    let resource = this.otSlots.getOTListArgs;
    if (this.otSlots.surgery_type == 'CathLab') {
      resource.query_id = "GET_USER_OT";
      resource.args.type = "cathlab"
    }
    else {
      resource.query_id = "GET_USER_OT";
      resource.args.type = "ot"
    }
    let data = {
      args: this.otService.getArguments(resource.args)
    }
    this.baseService.getData(data, "", "ot_user_mapping", "ot", resource.query_id).subscribe(
      res => {
        this.OTName = res.resource;
        //  this.showButton = false
      }
    )
  }

  public getDate(millis: any) {
    return _moment(millis).format("lll");
  }

  public getMilliseconds(date: any) {
    return _moment(date).format('x');
  }

  slotResult(event: any) {
    console.log('selected slot is as ::', event)
    if (event != undefined && event.slot_start_time != undefined && event.slot_end_time != undefined) {
      this.otSlots.selectedSlot = event;
      this.showButton = true;
      this.getSlotInfo(event.slot_start_time, event.slot_end_time - 1)
    }
    else {
      this.showButton = false;
    }
  }

  getSlotInfo(start: any, end: any) {
    return new Promise((resolve) => {
      this.baseService.get("GET_DOCTOR_SLOT_BY_ID_TIME", `practitioner_id:${this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "practitioner_id")},start_time:${start},end_time:${end}`, "appointment", "appointment").subscribe((res) => {
        if (res.errCode == 0) {
          if (res.count != 0) {
            this.alertService.error("Appoitment is already booked in this slot for " + this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "display_name") + ". Please Select Another Slot OR Cancel the Appointment");
            this.showButton = false;
          } else {
            resolve(true)
          }
        } else {
          resolve(true)
          this.alertService.error(res.message);
        }
      })
    })
  }

  public hasAcknowledged(event: any, isChecked: boolean) {
    // debugger
    if (event.target.value == "on") {
      this.otSlots.checkboxvalue = "acknowledged";
      this.showButton = true
      this.showTmeSlots = false;
      this.showSlots = false;
      this.otSlots.multipleSlots = false;
      this.otSlots.multiSlotsCheck = false;
      this.otSlots.selectedSlot = {};
    } else {
      this.otSlots.checkboxvalue = "";
      this.showButton = false;
      this.showTmeSlots = true;
      this.showSlots = true;
      this.otSlots.multipleSlots = true;
    }
    if (isChecked) {
      this.showButton = true
      this.showTmeSlots = false;
      this.showSlots = false;
      this.otSlots.multipleSlots = false;
      this.otSlots.selectedSlot = {};
    } else {
      this.showButton = false
      this.showTmeSlots = true;
      this.showSlots = true;
      this.otSlots.multipleSlots = true;
    }
  }
  previous() {
    this.router.queryParams.subscribe((urlParams) => {
      this.location.back();
    })
  }

  sendPickerResult(event) {
    this.otSlots.currentDate = event.date
    if (this.otSlots.OTId)
      this.getAppointsSlots(event.date, this.otSlots.OTId);
  }

  getTemplateConfig() {
    return {
      "next_stage": "Scheduled",
      "emitOnSubmit": true,
      "hideToaster": true,
      "checkPre": true,
      "setPrint": true,
      "datasource": {
        "query_id": "get_template_from_master",
        "application": "form-template-engine",
        "resource": "templateTransaction",
        "args": "stage:!!!next_stage!!!,care_type:!!!care_type!!!,gender:!!!gender!!!,patientType:!!!patientType!!!",
        "appendArgs": "serviceItemCode",
        "filter": ""
      }
    }
  }

  manupulateArgs(data: any[], args: string): any {
    let tempArgs = JSON.parse(JSON.stringify('!!!' + args + '!!!'));
    let finalargs = [];
    for (let val of data) {
      let strngVal = this.baseService.buildDyanamicStr(tempArgs, { 'data': val });
      finalargs.push(strngVal);
    }
    return args + ":" + finalargs.join('=');
  }

  checkTemplates(services: any[], onProceed: () => void) {
    try {
      this.loader.showSpinner();
      let config = this.getTemplateConfig();
      let datasource = config.datasource;
      let result: any = {
        ...(services && services[0] ? services[0] : {}),
        next_stage: config.next_stage,
        care_type: this.otSlots.patientData?.care_type,
        gender: this.otSlots.patientData?.patient_gender,
        patientType: this.patientDetails.patientType
      };
      if (!result.care_type) {
        try {
          result.care_type = this.appService.getDynamicFunctions("getCurrentCareType");
        } catch (error) { }
      }
      let args = this.baseService.buildDyanamicStr(datasource.args, { data: result });
      if (datasource.appendArgs) {
        args = args + "," + this.manupulateArgs(services, datasource.appendArgs);
      }
      this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
        this.loader.hideSpinner();
        if (data.errCode != -1 && data && data.resource != undefined && data.resource.length > 0) {
          config['TemplateData'] = data.resource;
          this.openTemplIntersep(result, { templateInterceptor: config }, false, (res) => {
            if (res) {
              onProceed();
            }
          });
        } else {
          onProceed();
        }
      }, () => {
        this.loader.hideSpinner();
        onProceed();
      });
    } catch (error) {
      this.loader.hideSpinner();
      onProceed();
    }
  }

  openTemplIntersep(data: any, actionType: any, config?: any, callback?: (res: any) => void) {
    let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
    if (config) {
      popobj.data['config'] = config
    }
    this.baseService.modalService.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe((res: any) => {
      if (res) {
        callback(res);
      } else {
        callback(false);
      }
    });
  }

  public async saveData() {
    if (this.otSlots.serviceItemId == '' || this.otSlots.surgeon_speciality_id == '' || this.otSlots.doctor_id == '') {
      this.alertService.error("Please Fill All Required Details");
      return;
    }
    if (this.formService && this.formService.questionMapping.re_exploration_reason.required && this.formData.re_exploration_reason == "") {
      this.alertService.error("Please Fill Surgical Indicator Reason");
      return;
    }
    if (this.formData && this.formData.bloodRequired == true) {
      if (this.formData.blood_required_details && this.formData.blood_required_details.length == 0) {
        this.alertService.error("Add Blood Required Details", "Add Blood Required Details")
        return
      }
    }
    if (this.formData && this.formData.surgery_schedule_remarks && this.formData.surgery_schedule_remarks.length > 256) {
      this.alertService.error("Lenght for Remarks should not be greater than 256")
      return;
    }
    if (await this.checkOffSchedule()) {
      return;
    }
    if (this.cArmArray.length > 0 && this.otSlots.c_arm_Required) {
      for (let i = 0; i < this.cArmArray.length; i++) {
        if (this.cArmArray[i].serviceStartTime == undefined || this.cArmArray[i].serviceStartTime == "") {
          delete this.cArmArray[i].serviceStartTime
        }
        if (this.cArmArray[i].serviceEndTime == undefined || this.cArmArray[i].serviceEndTime == "") {
          delete this.cArmArray[i].serviceEndTime
        }
        if (this.cArmArray[i].serviceDate == undefined || this.cArmArray[i].serviceDate == "") {
          delete this.cArmArray[i].serviceDate
        }
        if (this.cArmArray[i].serviceStartTime < this.otSlots.selectedSlot.slot_start_time || this.cArmArray[i].serviceStartTime > this.otSlots.selectedSlot.slot_end_time) {
          this.alertService.error("Please Select Machine Slot Between OT/Cathlab slot");
          return;
        }
      }
    }
    //service date and time us calendar selected or if acknowledeged click then today date
    let services = this.getSavableServices();
    this.checkTemplates(services, () => {
      this.loader.showSpinner()
      var patient = {
        "patient_details": {
          "patient_id": this.patientDetails.patient_id,
          "patientType": JSON.parse(sessionStorage.currentData)['patientType'],
          "uhId": JSON.parse(sessionStorage.currentData)['uhId'],
          "admissionId": JSON.parse(sessionStorage.currentData)['encounter_id'],
          "encounter_id": JSON.parse(sessionStorage.currentData)['encounter_id'],
          "payer_info": {
            "payer_id": this.patientDetails.payer_id
          }
        },
        "services": services
      }
      if (this.patientDetails.patientType != 'OP') {
        patient['total_amount'] = 0;
      }
      let action = '';
      if (this.patientDetails.patientType == 'OP') {
        action = 'OP_ORDER'
        patient['orderedFrom'] = 'OT Order',
          patient['order_type'] = 'OT',
          patient['encounter_id'] = this.patientDetails.encounter_id,
          patient['treatingDoctorId'] = this.otSlots.surgeon_id,
          patient['treatingDoctor'] = this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "display_name"),
          patient['treatingDoctorSpeciality'] = this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "text"),
          patient['treatingDoctorSpecialityCode'] = this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "value"),
          patient['order_device'] = "WEB",
          patient['episode_id'] = "",
          patient['care_type'] = this.otSlots.patientData.care_type,
          patient['care_type_name'] = this.otSlots.patientData.care_type_name,
          patient['billing_category_id'] = this.otSlots.patientData.billing_category_id,
          patient['billing_category_name'] = this.otSlots.patientData.billing_category,
          patient['order_from_counselling'] = this.otSlots.patientData.order_from_counselling,
          patient['old_serviceRequestId'] = this.otSlots.patientData.old_serviceRequetId
        if (this.otSlots.patientData.care_plan_id) {
          patient['surgery_from_care_plan'] = true;
        }
      }
      this.baseService.add(patient, "service_request_handler", true, "order", action).subscribe((result) => {
        // console.log()
        if (result.message.toLowerCase() == "success") {
          this.alertService.success("data saved successfully");
          this.previous();
        } else {
          this.loader.hideSpinner()
          this.alertService.error(result.message);
          this.otSlots.otServices = [];
        }
      },
        (err) => {
          this.loader.hideSpinner()
          console.error("error in getting data :: ", err)
        })
    });
  }
  onDropDownClose() {

  }

  public async savePrimeData() {
    if (this.otSlots.serviceItemId == '' || this.otSlots.surgeon_speciality_id == '' || this.otSlots.doctor_id == '') {
      this.alertService.error("Please Fill All Required Details");
      return;
    }
    if (!this.otSlots.rescheduling && this.formService && this.formService.questionMapping.re_exploration_reason.required && this.formData.re_exploration_reason == "") {
      this.alertService.error("Please Fill Surgical Indicator Reason");
      return;
    }
    if (this.formData && this.formData.bloodRequired == true) {
      if (this.formData.blood_required_details && this.formData.blood_required_details.length == 0) {
        this.alertService.error("Add Blood Required Details", "Add Blood Required Details")
        return
      }
    }
    if (this.formData && this.formData.surgery_schedule_remarks && this.formData.surgery_schedule_remarks.length > 256) {
      this.alertService.error("Lenght for Remarks should not be greater than 256")
      return;
    }
    if (await this.checkOffSchedule()) {
      return;
    }
    if (this.cArmArray.length > 0 && this.otSlots.c_arm_Required) {
      for (let i = 0; i < this.cArmArray.length; i++) {
        if (this.cArmArray[i].serviceStartTime == undefined || this.cArmArray[i].serviceStartTime == "") {
          delete this.cArmArray[i].serviceStartTime
        }
        if (this.cArmArray[i].serviceEndTime == undefined || this.cArmArray[i].serviceEndTime == "") {
          delete this.cArmArray[i].serviceEndTime
        }
        if (this.cArmArray[i].serviceDate == undefined || this.cArmArray[i].serviceDate == "") {
          delete this.cArmArray[i].serviceDate
        }
        if (this.cArmArray[i].serviceStartTime < this.otSlots.selectedSlot.slot_start_time || this.cArmArray[i].serviceStartTime > this.otSlots.selectedSlot.slot_end_time) {
          this.alertService.error("Please Select Machine Slot Between OT/Cathlab slot");
          return;
        }
      }
    }
    //service date and time us calendar selected or if acknowledeged click then today date
    let services = this.getSavableServices();
    this.checkTemplates(services, () => {
      this.loader.showSpinner()
      var patient = {
        "patient_details": {
          "patient_id": this.patientDetails.patient_id,
          "patientType": JSON.parse(sessionStorage.currentData)['patientType'],
          "uhId": JSON.parse(sessionStorage.currentData)['uhId'],
          "admissionId": JSON.parse(sessionStorage.currentData)['encounter_id'],
          "encounter_id": JSON.parse(sessionStorage.currentData)['encounter_id'],
          "payer_info": {
            "payer_id": this.patientDetails.payer_id
          }
        },
        "services": services,
        "total_amount": 0,
        "facility_id": this.appService.getOrganization().org_id
      }
      var service_request = {
        "service_request_handler": patient,
        "surgery_request_id": JSON.parse(sessionStorage.getItem('currentData'))['id'],
        "general_slot": this.otSlots.general_slots,
        "prime_slot": this.otSlots.prime_slots,
      }

      if (this.patientDetails.patientType == 'OP') {
        patient['orderedFrom'] = "OT Order",
          patient['order_type'] = "OT",
          patient['encounter_id'] = this.patientDetails.encounter_id,
          patient['treatingDoctorId'] = this.otSlots.surgeon_id,
          patient['treatingDoctor'] = this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "display_name"),
          patient['treatingDoctorSpeciality'] = this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "display"),
          patient['treatingDoctorSpecialityCode'] = this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "code"),
          patient['order_device'] = "WEB",
          patient['episode_id'] = "",
          patient['care_type'] = this.otSlots.patientData.care_type,
          patient['care_type_name'] = this.otSlots.patientData.care_type_name,
          patient['order_from_counselling'] = this.otSlots.patientData.order_from_counselling,
          patient['billing_category_id'] = this.otSlots.patientData.billing_category_id,
          patient['billing_category_name'] = this.otSlots.patientData.billing_category,
          patient['old_serviceRequestId'] = this.otSlots.patientData.old_serviceRequetId
        if (this.otSlots.patientData.care_plan_id) {
          patient['surgery_from_care_plan'] = true;
        }
      }
      this.baseService.add(service_request, "surgery_authorization", true, "ot").subscribe((result) => {
        // console.log()
        if (result.message.toLowerCase() == "success") {
          this.alertService.success("data saved successfully");
          this.loader.hideSpinner()
          this.previous();
        } else {
          this.loader.hideSpinner()
          this.alertService.error(result.message);
          this.otSlots.otServices = [];
        }
      },
        (err) => {
          this.loader.hideSpinner()
          console.error("error in getting data :: ", err)
        })
    });
  }

  onItemDeSelect(item: any) {
    this.disabledButton = false;
  }
  onItemSelect(surgeryId) {
    this.otSlots.additionalSurgeries.push(surgeryId)
    if (this.otSlots.exist == true) {
      for (let i = 0; i < this.otSlots.multisurgeryName.length; i++) {
        if (this.otSlots.multisurgeryName[i].id == surgeryId.id) {
          if (this.otSlots.multisurgeryName[i].finance_clearance == true) {
            this.disabledButton = false;
          }
          else if (this.otSlots.multisurgeryName[i].finance_clearance == false) {
            this.alertService.error("Please Finance Clearance!!!");
            this.disabledButton = true;
          }
        }
      }
    }
  }

  onSelectAll(allSelecteddata) {
    this.otSlots.otServices = [];
    this.otSlots.otServices.push(allSelecteddata);
  }

  getSavableServices() {
    if (this.otSlots.additionalSurgeries.length > 0) {
      for (let i = 0; i < this.otSlots.additionalSurgeries.length; i++) {
        let surgery = this.otSlots.multisurgeryName.find(val => val.id == this.otSlots.additionalSurgeries[i].id
        )
        if (surgery) {
          // this.otServices.push(surgery)
          this.setSurgeryRequests(surgery);
          // console.log("ot surgery request is as ::", surgery)
        }
      }
    }
    this.setSavableObj();
    return this.otSlots.otServices
  }

  setSurgeryRequests(surgery) {
    let obj = {
      "status": surgery.status,
      "serviceType": this.otSlots.serviceType == undefined ? "" : this.otSlots.serviceType,
      "serviceType_code": this.otSlots.serviceType_code == undefined ? "" : this.otSlots.serviceType_code,
      "slotId": this.otSlots.selectedSlot == undefined ? "" : this.otSlots.selectedSlot.id,
      "serviceDate": this.otSlots.selectedSlot != undefined && this.otSlots.selectedSlot.slot_date != undefined ? this.otSlots.selectedSlot.slot_date : this.otSlots.patientData.expected_surgery_date_time,
      "serviceStartTime": this.otSlots.selectedSlot && this.otSlots.selectedSlot.slot_start_time ? this.otSlots.selectedSlot.slot_start_time : this.otSlots.currentDate,
      "serviceEndTime": this.otSlots.selectedSlot && this.otSlots.selectedSlot.slot_end_time ? this.otSlots.selectedSlot.slot_end_time : this.otSlots.currentDate,
      "kinContact": this.otSlots.kinContact,
      "kinRelationship": this.otSlots.kinRelationship,
      "kinGender": this.otSlots.kinGender,
      "kinName": this.otSlots.kinName,
      "category": "surgeon",
      "identifier": surgery.id,
      "serviceItemCode": surgery.serviceItemCode,
      "serviceItemName": surgery.serviceItemName,
      "serviceItemId": surgery.serviceItemId,
      "walkinPatient": false,
      "department_id": surgery.department_id,
      "department_name": surgery.department,
      "subDepartment_id": surgery.subDepartment_id,
      "subDepartment_name": surgery.subDepartment_name,
      "surgeon_details": this.formData.surgeon_details,
      "general_slot": this.otSlots.general_slots,
      "prime_slot": this.otSlots.prime_slots,
      "alos": this.formData.alos,
      "surgery_type": this.otSlots.surgery_type,
      "bloodRequired": this.formData.bloodRequired,
      "blood_required_details": this.formData.bloodRequired ? this.formData.blood_required_details : [],
      "born_surgery": this.formData.born_surgery,
      "cosmetic_surgery": this.formData.cosmetic_surgery,
      "dentist_required": this.formData.dentist_required,
      "emergency_surcharge": this.formData.emergency_surcharge,
      "highRisk": this.formData.highRisk,
      "icuRequired": this.formData.icuRequired,
      "highRisk_remarks": this.formData.highRisk_remarks,
      "implantRequired": this.formData.implantRequired,
      "implant_insituImplantDetails": this.formData.implant_insituImplantDetails,
      "specialEquipmentRequired": this.formData.specialEquipmentRequired,
      "special_equipment_remarks": this.formData.special_equipment_remarks,
      "scheduling_required": this.formData.scheduling_required,
      "robotics_required": this.formData.robotics_required,
      "surgery_schedule_remarks": this.formData.surgery_schedule_remarks,
      "pacRequired": this.formData.pacRequired,
      "ot_surgery_type_code": this.formData.ot_surgery_type_code,
      "surgery_notes": this.formData.surgery_notes,
      "implant_remarks": this.formData.implant_remarks,
      "anesthesia_subtype": this.formData.anesthesia_subtype_id ? this.formData.anesthesia_subtype : '',
      "anesthesia_subtype_id": this.formData.anesthesia_subtype_id,
      "anesthesia_type": this.formData.anesthesia_type,
      "anesthesia": this.formData.anesthesia_type ? this.formData.anesthesia : '',
      "anesthesia_indicator_code": this.formData.anesthesia_indicator_code,
      "anesthesia_indicator": this.formData.anesthesia_indicator_code ? this.formData.anesthesia_indicator : '',
      "surgical_indicator_code": this.formData.surgical_indicator_code,
      "surgical_indicator": this.formData.surgical_indicator_code ? this.formData.surgical_indicator : '',
      "re_exploration_reason": this.formData.re_exploration_reason,
      "re_exploration_remarks": this.formData.re_exploration_remarks,
      "data": this.cArmArray,
      "standard_codes": this.otSlots.patientData && this.otSlots.patientData.standard_codes ? this.otSlots.patientData.standard_codes : [],
      "participant": [
        {
          "participantId": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "practitioner_id"),
          "participantName": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "display_name"),
          "participantRole": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "userRole"),
          "extra_data": {
            "surgeon_speciality": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "text"),
            "surgeon_speciality_code": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "value"),
            "surgeon_speciality_id": this.otSlots.surgeon_speciality_id
          }
        },
        {
          "participantId": this.otSlots.OTId,
          "participantName": this.getData(this.otSlots.OTId, this.OTName, "id", "name"),
          "participantRole": this.getData(this.otSlots.OTId, this.OTName, "id", "roomtype_id"),
          "action": this.otSlots.checkboxvalue
        }
      ],
      "qty": 1,
      "remarks": ""
    }
    if (obj['blood_required_details'] && obj['blood_required_details'].length != 0) {
      obj['blood_group'] = obj['blood_required_details'][0]['blood_group'];
    }
    if (this.patientDetails.patientType == 'OP') {
      obj['patient_amount'] = this.opAmount.patient_amount,
        obj['discount'] = this.opAmount.discount,
        obj['net_amount'] = this.opAmount.net_amount,
        obj['total_amount'] = this.opAmount.total_amount,
        obj['service_mrp'] = this.opAmount.service_mrp,
        obj['priorityCode'] = this.opAmount.priorityCode,
        obj['priority'] = this.opAmount.priority,
        obj['price'] = this.opAmount.price,
        obj['billing_category_id'] = this.otSlots.patientData.billing_category_id,
        obj['billing_category_name'] = this.otSlots.patientData.billing_category
      obj['referenceId'] = this.patientDetails.referenceId ? this.patientDetails.referenceId : this.patientDetails.encounter_id
    }
    this.otSlots.otServices.push(obj);
    // return this.otServices
  }

  setSavableObj() {
    let obj = {
      "status": JSON.parse(sessionStorage.currentData)['status'],
      "serviceType": this.otSlots.serviceType == undefined ? "" : this.otSlots.serviceType,
      "serviceType_code": this.otSlots.serviceType_code == undefined ? "" : this.otSlots.serviceType_code, "slotId": this.otSlots.selectedSlot == undefined ? "" : this.otSlots.selectedSlot.id,
      "serviceDate": this.otSlots.selectedSlot != undefined && this.otSlots.selectedSlot.slot_date != undefined ? this.otSlots.selectedSlot.slot_date : this.otSlots.patientData.expected_surgery_date_time,
      "serviceStartTime": this.otSlots.selectedSlot && this.otSlots.selectedSlot.slot_start_time ? this.otSlots.selectedSlot.slot_start_time : this.otSlots.currentDate,
      "serviceEndTime": this.otSlots.selectedSlot && this.otSlots.selectedSlot.slot_end_time ? this.otSlots.selectedSlot.slot_end_time : this.otSlots.currentDate,
      "category": "surgeon",
      "identifier": JSON.parse(sessionStorage.getItem('currentData'))['id'],
      "serviceItemCode": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "identifier"),
      "serviceItemName": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "name"),
      "serviceItemId": this.otSlots.serviceItemId,
      "walkinPatient": false,
      "department_id": this.otSlots.department_id,
      "department_name": this.getData(this.otSlots.department_id, this.otSlots.departmentList, "id", "name"),
      "subDepartment_id": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "subDepartment_id"),
      "subDepartment_name": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "subDepartment_name"),
      "kinContact": this.otSlots.kinContact,
      "kinRelationship": this.otSlots.kinRelationship,
      "kinGender": this.otSlots.kinGender,
      "kinName": this.otSlots.kinName,
      "surgeon_details": this.formData.surgeon_details,
      "c_arm_Required": this.otSlots.c_arm_Required,
      "general_slot": this.otSlots.general_slots,
      "prime_slot": this.otSlots.prime_slots,
      "surgery_type": this.otSlots.surgery_type,
      "alos": this.formData.alos,
      "bloodRequired": this.formData.bloodRequired,
      "blood_required_details": this.formData.bloodRequired ? this.formData.blood_required_details : [],
      "born_surgery": this.formData.born_surgery,
      "cosmetic_surgery": this.formData.cosmetic_surgery,
      "dentist_required": this.formData.dentist_required,
      "emergency_surcharge": this.formData.emergency_surcharge,
      "highRisk": this.formData.highRisk,
      "icuRequired": this.formData.icuRequired,
      "highRisk_remarks": this.formData.highRisk_remarks,
      "implantRequired": this.formData.implantRequired,
      "implant_insituImplantDetails": this.formData.implant_insituImplantDetails,
      "specialEquipmentRequired": this.formData.specialEquipmentRequired,
      "special_equipment_remarks": this.formData.special_equipment_remarks,
      "scheduling_required": this.formData.scheduling_required,
      "robotics_required": this.formData.robotics_required,
      "pacRequired": this.formData.pacRequired,
      "ot_surgery_type_code": this.formData.ot_surgery_type_code,
      "surgery_notes": this.formData.surgery_notes,
      "implant_remarks": this.formData.implant_remarks,
      "anesthesia_subtype": this.formData.anesthesia_subtype_id ? this.formData.anesthesia_subtype : '',
      "anesthesia_subtype_id": this.formData.anesthesia_subtype_id,
      "anesthesia_type": this.formData.anesthesia_type,
      "anesthesia": this.formData.anesthesia_type ? this.formData.anesthesia : '',
      "anesthesia_indicator_code": this.formData.anesthesia_indicator_code,
      "anesthesia_indicator": this.formData.anesthesia_indicator_code ? this.formData.anesthesia_indicator : '',
      "surgical_indicator_code": this.formData.surgical_indicator_code,
      "surgical_indicator": this.formData.surgical_indicator_code ? this.formData.surgical_indicator : '',
      "re_exploration_reason": this.formData.re_exploration_reason,
      "re_exploration_remarks": this.formData.re_exploration_remarks,
      "surgery_schedule_remarks": this.formData.surgery_schedule_remarks,
      "data": this.cArmArray,
      "standard_codes": this.otSlots.patientData && this.otSlots.patientData.standard_codes ? this.otSlots.patientData.standard_codes : [],
      "participant": [
        {
          "participantId": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "practitioner_id"),
          "participantName": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "display_name"),
          "participantRole": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "userRole"),
          "extra_data": {
            "surgeon_speciality": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "text"),
            "surgeon_speciality_code": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "value"),
            "surgeon_speciality_id": this.otSlots.surgeon_speciality_id
          }
        },
        {
          "participantId": this.otSlots.OTId,
          "participantName": this.getData(this.otSlots.OTId, this.OTName, "id", "name"),
          "participantRole": this.getData(this.otSlots.OTId, this.OTName, "id", "roomtype_id"),
          "action": this.otSlots.checkboxvalue
        }
      ],
      "qty": 1,
      "remarks": ""
    }
    if (obj['blood_required_details'] && obj['blood_required_details'].length != 0) {
      obj['blood_group'] = obj['blood_required_details'][0]['blood_group'];
    }
    if (this.patientDetails.patientType == 'OP') {
      obj['patient_amount'] = this.opAmount.patient_amount,
        obj['discount'] = this.opAmount.discount,
        obj['net_amount'] = this.opAmount.net_amount,
        obj['total_amount'] = this.opAmount.total_amount,
        obj['service_mrp'] = this.opAmount.service_mrp,
        obj['priorityCode'] = this.opAmount.priorityCode,
        obj['priority'] = this.opAmount.priority,
        obj['price'] = this.opAmount.price,
        obj['billing_category_id'] = this.otSlots.patientData.billing_category_id,
        obj['billing_category_name'] = this.otSlots.patientData.billing_category
      obj['service_selling_amount'] = this.opAmount.service_selling_amount
      obj['referenceId'] = this.patientDetails.referenceId ? this.patientDetails.referenceId : this.patientDetails.encounter_id
    }
    this.otSlots.otServices.push(obj);
    // return this.otServices
  }
  getData(data: any, resource: any, keyword: any, keytoreturn: any) {
    if (data != '' && resource != '') {
      let obj = resource.find(x => x[keyword] == data)
      return obj != undefined ? obj[keytoreturn] : this.loader.hideSpinner();
    }
  }

  opPackageValidation() {
    var data = {
      args: "package_id:" + this.otSlots.serviceItemId + ",payer_id:" + this.patientDetails.payer_id + ",billing_category_id:" + this.otSlots.patientData.billing_category_id
    }
    this.baseService.getData(data, "", "package_detail", "facility-management", "GET_PACKAGE_DETAIL").subscribe(
      result => {
        if (result.errCode == -1) {
          this.alertService.error(result.message);
          this.opPackageValidationFailed = true;
        }
      }
    )
    let argsPrice = {
      args: `serviceId:${this.otSlots.serviceItemId},payer_id:${this.patientDetails.payer_id},patient_id:${this.patientDetails.patient_id},billingCategoryId:${this.otSlots.patientData.billing_category_id},serviceType:package,quantity:1,serviceType_code:package,care_type:${this.otSlots.patientData.care_type}`
    }
    this.baseService.getData(argsPrice, "", "tariff_service_item", "facility-management", "GET_SERVICE_ITEM_PRICE").subscribe(
      res => {
        if (res.errCode == -1) {
          this.alertService.error(res.message);
          this.opPackageValidationFailed = true;
        }
      })
  }

  public savePackageData() {
    this.loader.showSpinner();
    if (this.otSlots.serviceItemId == '' || this.otSlots.surgeon_speciality_id == '' || this.otSlots.doctor_id == '') {
      this.loader.hideSpinner()
      this.alertService.error("Please Fill All Required Details");
      return;
    }
    if (this.otSlots.serviceType_code == 'surgery' && this.rescheduleReasonRemarkMandate && (this.otSlots.reschedule_reason == "" || this.otSlots.reschedule_remarks == "")) {
      this.loader.hideSpinner()
      this.alertService.error("Please Fill Reason and Remark");
      return;
    }
    if (this.otSlots.serviceType_code == 'package' && !this.otSlots.rescheduling && this.formService && this.formService.questionMapping.re_exploration_reason.required && this.formData.re_exploration_reason == "") {
      this.loader.hideSpinner()
      this.alertService.error("Please Fill Surgical Indicator Reason");
      return;
    }
    if (this.formData && this.formData.bloodRequired == true && !this.otSlots.rescheduling) {
      if (this.formData.blood_required_details && this.formData.blood_required_details.length == 0) {
        this.loader.hideSpinner()
        this.alertService.error("Add Blood Required Details", "Add Blood Required Details")
        return
      }
    }
    if (this.opPackageValidationFailed) {
      this.loader.hideSpinner()
      this.alertService.error("Package/service price criteria not defined");
      return;
    }
    if (this.formData && !this.otSlots.rescheduling && this.formData.surgery_schedule_remarks && this.formData.surgery_schedule_remarks.length > 256) {
      this.alertService.error("Lenght for Remarks should not be greater than 256")
      return;
    }
    if (this.cArmArray.length > 0) {
      for (let i = 0; i < this.cArmArray.length; i++) {
        if (this.cArmArray[i].serviceStartTime == undefined || this.cArmArray[i].serviceStartTime == "") {
          delete this.cArmArray[i].serviceStartTime
        }
        if (this.cArmArray[i].serviceEndTime == undefined || this.cArmArray[i].serviceEndTime == "") {
          delete this.cArmArray[i].serviceEndTime
        }
        if (this.cArmArray[i].serviceDate == undefined || this.cArmArray[i].serviceDate == "") {
          delete this.cArmArray[i].serviceDate
        }
        if (this.cArmArray[i].serviceStartTime < this.otSlots.selectedSlot.slot_start_time || this.cArmArray[i].serviceStartTime > this.otSlots.selectedSlot.slot_end_time) {
          this.loader.hideSpinner()
          this.alertService.error("Please Select Machine Slot Between Ot/Cathlab slot");
          return;
        }
      }
    }
    let packageObj = {
      "id": this.otSlots.id,
      "uhId": JSON.parse(sessionStorage.currentData)['uhId'],
      "admissionId": JSON.parse(sessionStorage.currentData)['encounter_id'],
      "encounter_id": JSON.parse(sessionStorage.currentData)['encounter_id'],
      "service_request_id": JSON.parse(sessionStorage.currentData)['service_request_id'],
      "service_order_id": JSON.parse(sessionStorage.currentData)['service_order_id'],
      "serviceItemCode": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "identifier"),
      "serviceItemName": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "name"),
      "serviceItemId": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "id"),
      "doctor_id": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "id"),
      "department_id": this.otSlots.department_id,
      "department": this.getData(this.otSlots.department_id, this.otSlots.departmentList, "id", "name"),
      "subDepartment_id": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "subDepartment_id"),
      "subDepartment_name": this.getData(this.otSlots.serviceItemId, this.otSlots.surgeryName, "id", "subDepartment_name"),
      "surgeon_speciality": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "text"),
      "surgeon_speciality_code": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "value"),
      "surgeon_speciality_id": this.getData(this.otSlots.surgeon_speciality_id, this.otSlots.surgeonSpeciality, "id", "id"),
      "surgeon": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "display_name"),
      "surgeon_id": this.getData(this.otSlots.doctor_id, this.otSlots.surgeonData, "id", "practitioner_id"),
      "service_date": this.otSlots.selectedSlot != undefined && this.otSlots.selectedSlot.slot_date != undefined ? this.otSlots.selectedSlot.slot_date : this.otSlots.serviceDate,
      "service_start_time": this.otSlots.selectedSlot != undefined && this.otSlots.selectedSlot.slot_start_time != undefined ? this.otSlots.selectedSlot.slot_start_time : this.otSlots.serviceDate,
      "service_end_time": this.otSlots.selectedSlot == undefined ? this.otSlots.currentDate : this.otSlots.selectedSlot.slot_end_time,
      "serviceType": this.otSlots.serviceType == undefined ? "" : this.otSlots.serviceType,
      "serviceType_code": this.otSlots.serviceType_code == undefined ? "" : this.otSlots.serviceType_code,
      "ot_id": this.otSlots.OTId,
      "kinContact": this.otSlots.kinContact,
      "kinRelationship": this.otSlots.kinRelationship,
      "kinGender": this.otSlots.kinGender,
      "kinName": this.otSlots.kinName,
      "ot_name": this.getData(this.otSlots.OTId, this.OTName, "id", "name"),
      "surgery_schedule_remarks": this.formData.surgery_schedule_remarks,
      "c_arm_Required": this.otSlots.c_arm_Required,
      "surgeon_details": this.formData.surgeon_details,
      "bloodRequired": this.formData.bloodRequired,
      "blood_required_details": this.formData.bloodRequired ? this.formData.blood_required_details : [],
      "born_surgery": this.formData.born_surgery,
      "surgery_percentage_name": this.formData.surgery_percentage_name,
      "is_main_package": this.formData.is_main_package,
      "scheduling_required": this.formData.scheduling_required,
      "icuRequired": this.formData.icuRequired,
      "implantRequired": this.formData.implantRequired,
      "implant_insituImplantDetails": this.formData.implant_insituImplantDetails,
      "implant_remarks": this.formData.implant_remarks,
      "pacRequired": this.formData.pacRequired,
      "surgery_notes": this.formData.surgery_notes,
      "reschedule_reason": this.otSlots.reschedule_reason,
      "reschedule_remarks": this.otSlots.reschedule_remarks,
      "anesthesia_subtype": this.formData.anesthesia_subtype_id ? this.formData.anesthesia_subtype : '',
      "anesthesia_subtype_id": this.formData.anesthesia_subtype_id,
      "anesthesia_type": this.formData.anesthesia_type,
      "anesthesia": this.formData.anesthesia_type ? this.formData.anesthesia : '',
      "anesthesia_indicator_code": this.formData.anesthesia_indicator_code,
      "anesthesia_indicator": this.formData.anesthesia_indicator_code ? this.formData.anesthesia_indicator : '',
      "surgical_indicator_code": this.formData.surgical_indicator_code,
      "surgical_indicator": this.formData.surgical_indicator_code ? this.formData.surgical_indicator : '',
      "re_exploration_reason": this.formData.surgical_indicator_code ? this.formData.re_exploration_reason : '',
      "re_exploration_remarks": this.formData.surgical_indicator_code ? this.formData.re_exploration_remarks : '',
      "equipment_details": this.cArmArray,
    }
    if (packageObj['blood_required_details'] && packageObj['blood_required_details'].length != 0) {
      packageObj['blood_group'] = packageObj['blood_required_details'][0]['blood_group'];
    }
    this.checkTemplates([packageObj], () => {
      if (this.otSlots.scheduling == "Schedule Surgery/Package") {
        this.baseService.action(packageObj, "SCHEDULE_PACKAGE_REQUEST", "ot", "surgery_request").subscribe(
          res => {
            if (res.errCode == 0) {
              this.alertService.success("Updated Successfully");
              this.loader.hideSpinner()
              this.previous();
            }
            else if (res.errCode == -1) {
              this.alertService.error(res.message);
              this.loader.hideSpinner()
            }
          })
      }
      else if (this.otSlots.rescheduling == "Reschedule Surgery/Package") {
        this.baseService.action(packageObj, "RESCHEDULE_PACKAGE_SURGERY", "ot", "surgery_request").subscribe(
          res => {
            if (res.errCode == 0) {
              this.alertService.success("Updated Successfully");
              this.loader.hideSpinner()
              this.previous();
            }
            else if (res.errCode == -1) {
              this.alertService.error(res.message);
              this.loader.hideSpinner()
            }
          })
      }
    });
  }
  onChange(event: any) {
    console.log("event is : ", event);
  }
  getDoctorSlots() {
    this.loader.showSpinner()
    this.showSlots = false
    for (let i = 0; i < this.otSlots.surgeonData.length; i++) {
      if (this.otSlots.surgeonData[i].id == this.otSlots.doctor_id) {
        this.doctor_id = this.otSlots.surgeonData[i].practitioner_id;
        break;
      }
      else {
        this.doctor_id = ""
      }
    }
    let data = {
      "doctorId": this.doctor_id
    }
    if (this.doctor_id == "" || this.doctor_id == undefined) {
      this.loader.hideSpinner()
      this.alertService.error("Please Select Doctor")
    }
    else {
      this.baseService.modalService.dialogService.open(OtSlotsViewComponent, { data: data, size: DialogModalSize.Lg }).afterClosed.subscribe((res: any) => {
        console.log("res is :: ", res)
        this.loader.hideSpinner()
        if (res == undefined || res) {
          this.showSlots = true
        }
      }, error => {
        this.loader.hideSpinner()
        console.error("Error in getting data ", error)
      })
    }
  }
  // viewCalender() {
  //   let otName = this.OTName[0].name.replace(/\s/g, ',').split(",").map(x => x.charAt(0).toUpperCase() + x.substr(1).toLowerCase()).join(" ")
  //   let componentConfig = {
  //     inputs: { data: { id: this.otSlots.OTId, resource: "calendar_event_ot", title: otName } }
  //   };
  //   this.aside.appendComponentTo('aside-modal-container', EventCalendarComponent, componentConfig, 'xl', "Calendar of " + otName).subscribe(data => {
  //     if (data) {
  //       // this.getPackageDetail()
  //       console.log("res is :: ", data)
  //     }
  //   });
  // }
  generalSlots(event: any, isChecked: boolean) {
    this.otSlots.general_slots = isChecked;
    this.getAppointsSlots(this.otSlots.currentDate, this.otSlots.OTId)
  }
  primeSlots(event: any, isChecked: boolean) {
    this.otSlots.prime_slots = isChecked;
    this.getAppointsSlots(this.otSlots.currentDate, this.otSlots.OTId)
  }

  equipments(event) {
    this.cArmArray = event
  }
  // eventFired(event) {
  //   this.otSlots.billingComponent = event.items
  //   //this.otSlots.billingComponent = this.otSlots.billingComponent.push(...event.items)
  // }
  beforeSubmitValidation(result: any, currentBtnVal: any) {
    if (result.currentForm.value != undefined && result.currentForm.value.is_surgeon == true && this.formData.surgeon_details != undefined && this.formData.surgeon_details.length != 0) {
      let num: any;
      for (let i = 0; i < this.formData.surgeon_details.length; i++) {
        if (this.formData.surgeon_details[i].is_surgeon == true) {
          num = 1;
          break;
        }
        else
          num = 0;
      }
      if (num == 1) {
        this.alertService.error("Can't add more than 1 main surgeon");
        return false;
      }
    }
    if (result.currentForm.value != undefined && result.currentForm.value.blood_group && this.formData.blood_required_details.length != 0) {
      if (result.currentForm.value.blood_group != this.formData.blood_required_details[0].blood_group) {
        this.alertService.error("You can not add blood component with different blood group");
        return false;
      }
    }
    return true
  }

  async checkOffSchedule(): Promise<boolean> {
    if (!this.otSlots.surgeon_id) {
      return false;
    }
    return await this.otService.checkDoctoroffScheduleExits(this.otSlots);
  }
}